module.exports = __webpack_public_path__ + "img/white-bar-chart-icon.326cfd6d.svg";